/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Paypal_EnvironmentInputs */

const en_admin_settings_fields_paypal_environment = /** @type {(inputs: Admin_Settings_Fields_Paypal_EnvironmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environment`)
};

/**
* | output |
* | --- |
* | "Environment" |
*
* @param {Admin_Settings_Fields_Paypal_EnvironmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_paypal_environment = /** @type {((inputs?: Admin_Settings_Fields_Paypal_EnvironmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Paypal_EnvironmentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_paypal_environment(inputs)
});
export { admin_settings_fields_paypal_environment as "admin.settings.fields.paypal_environment" }